var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticStyle: { display: "inline-block" } }, [
      _vm.currentStatus === false
        ? _c(
            "button",
            {
              class: "btn btn-primary " + this.size,
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.join()
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.type === "group"
                      ? _vm.__("globals.join")
                      : _vm.__("globals.follow")
                  ) +
                  " "
              ),
              _c("i", { staticClass: "feather icon-user-plus" }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStatus === true
        ? _c(
            "button",
            {
              class: "btn btn-primary " + this.size,
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.leaveQuestionCheck()
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.type === "group"
                      ? _vm.__("globals.leave")
                      : _vm.__("globals.unfollow")
                  ) +
                  " "
              ),
              _c("i", { staticClass: "feather icon-log-out" }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStatus === "pending"
        ? _c(
            "button",
            {
              class: "btn btn-primary " + this.size,
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.leave()
                },
              },
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.__("globals.requested")) + " "
              ),
              _c("i", { staticClass: "feather icon-log-in" }),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.leave_modal
      ? _c(
          "div",
          [
            _c("leave-service-modal", {
              attrs: {
                type: "group",
                slug: _vm.slug,
                leave_question: _vm.leave_question,
              },
              on: {
                "question-complete": function ($event) {
                  return _vm.questionComplete()
                },
                "close-modal": function ($event) {
                  return _vm.triggerModal()
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }